module.exports = __webpack_public_path__ + "static/media/helpcenter.8b1632bd.svg";